import * as React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {
	Box,
	Stack,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
	Typography
} from "@mui/material";
import SearchBar from "material-ui-search-bar";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import GirlIcon from "@material-ui/icons/Face";
import { getModelsEarnings } from "../../redux/actions/modelAction";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const mapStateToProps = (state) => {
	return {
		models_earnings: state.models_earnings
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getModelsEarnings: () => dispatch(getModelsEarnings())
	};
};

function Earnings({ getModelsEarnings, models_earnings }) {
	React.useEffect(() => {
		getModelsEarnings();
	}, []);

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		"&:nth-of-type(odd)": {
			backgroundColor: "rgb(0 0 0)"
		},
		"&:nth-of-type(even)": {
			backgroundColor: "#ffffff14"
		},
		// hide last border
		"&:last-child td, &:last-child th": {
			border: 0
		},
		"&.MuiTableRow-root:hover": {
			backgroundColor: "#555555"
		}
	}));

	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: "#292929",
			color: theme.palette.common.white
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14
		}
	}));

	const [rows, setRows] = React.useState(models_earnings);

	React.useEffect(() => {
		setRows(models_earnings);
	}, [models_earnings]);

	const [searched, setSearched] = React.useState("");

	const requestSearch = (searchVal) => {
		const filtereredRows = models_earnings.filter((row) => {
			return row.inHouseName.toLowerCase().includes(searchVal.toLowerCase());
		});
		setRows(filtereredRows);
	};
	const cancelSearch = () => {
		setSearched("");
		requestSearch(searched);
	};

	let navigate = useNavigate();
	const loading = useSelector((state) => state.loading);
	return (
		<>
			<Stack
				className="page-container"
				spacing={3}
				sx={{ width: 600, marginLeft: "290px" }}
			>
				{loading && loading.isLoading == true ? (
					<div className="loader-container">
						<div className="spinner"></div>
					</div>
				) : (
					""
				)}
				<Box>
					<Grid container spacing={0}>
						<Grid item xs={4} md={2} spacing={0} className="LiveShow">
							<Typography
								variant="h4"
								gutterBottom
								component="div"
								style={{ color: "white" }}
							>
								Earnings
							</Typography>
						</Grid>
					</Grid>
				</Box>
				<Box className="Search_box">
					<Typography
						variant="h6"
						gutterBottom
						component="div"
						style={{ color: "white", marginRight: "63px" }}
					>
						Find housemate
					</Typography>
					<SearchBar
						style={{ height: "35px" }}
						className="SearchBar"
						placeholder=""
						value={searched}
						onChange={(searchVal) => requestSearch(searchVal)}
						onCancelSearch={() => cancelSearch()}
					/>
				</Box>
				<TableContainer
					className="SchrollBar"
					component={Paper}
					style={{ overflow: "auto", marginRight: "40px" }}
					sx={{ maxHeight: "800px" }}
				>
					<Table aria-label="simple table" stickyHeader>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell style={{ borderBottom: "none" }} align="left">
									Housemate
								</StyledTableCell>
								<StyledTableCell style={{ borderBottom: "none" }} align="right">
									This Month Earnings
								</StyledTableCell>
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{rows &&
								rows.map((row) => (
									<StyledTableRow
										className="transition"
										onClick={() => {
											navigate("/modelEarnings/" + row.id);
										}}
										key={row.id}
										sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
									>
										<TableCell
											align="left"
											style={{
												borderBottom: "none",
												color: "#78F73B",
												display: "flex",
												alignItems: "center"
											}}
										>
											<GirlIcon
												style={{ color: "white", marginRight: "10px" }}
											/>
											{row.inHouseName}
										</TableCell>
										<TableCell
											align="right"
											style={{ borderBottom: "none", color: "#FFD800" }}
										>
											{row.amount == null ? 0 : row.amount}
										</TableCell>
									</StyledTableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>
			</Stack>
		</>
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(Earnings);
